

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('circle', {"cx":"9","cy":"9","r":"8.5","fill":"#E2B400","stroke":"white"}, []), "\n", h('path', {"d":"M9.76875 10.9688H8.24375L7.925 4.8625H10.0875L9.76875 10.9688ZM7.9 13.1063C7.9 12.7563 7.99375 12.4917 8.18125 12.3125C8.36875 12.1333 8.64167 12.0438 9 12.0438C9.34583 12.0438 9.6125 12.1354 9.8 12.3188C9.99167 12.5021 10.0875 12.7646 10.0875 13.1063C10.0875 13.4354 9.99167 13.6958 9.8 13.8875C9.60833 14.075 9.34167 14.1687 9 14.1687C8.65 14.1687 8.37917 14.0771 8.1875 13.8938C7.99583 13.7063 7.9 13.4438 7.9 13.1063Z","fill":"white"}, []), "\n"]);
};

        